// Single source of truth for Siddhivinayak Group's NAP (Name, Address,
// Phone) and brand identifiers. Reused by homepage JSON-LD (homeSchema.js),
// future contact/about/footer schemas, and any component that needs to
// display verified contact details.
export const NAP = {
  brand: "Siddhivinayak Group",
  legalName: "Siddhivinayak Infrastructure",
  parentGroup: "Kunal Padole Group",
  phone: "+91-9823260303",
  phoneDisplay: "+91 98232 60303",
  email: "mail@kunalpadole.com",
  streetAddress:
    "No. 1/3/731, Raje Raghuji Nagar, Opp. Kamala Nehru College",
  addressLocality: "Nagpur",
  addressRegion: "Maharashtra",
  postalCode: "440009",
  addressCountry: "IN",
  geo: { lat: 21.1458, lng: 79.0882 },
  hours: ["Mo-Sa 10:00-19:00"],
  siteUrl:
    process.env.NEXT_PUBLIC_SITE_URL || "https://siddhivinayakinfra.in",
};
